import { render, staticRenderFns } from "./MypeMonthIncomeDetails.vue?vue&type=template&id=0381a292&"
import script from "./MypeMonthIncomeDetails.vue?vue&type=script&lang=js&"
export * from "./MypeMonthIncomeDetails.vue?vue&type=script&lang=js&"
import style0 from "./MypeMonthIncomeDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports